import { NetworkName } from './network'

export const assets: Record<NetworkName, AssetData[]> = {
  mainnet: [],
  testnet: [
    // {
    //   symbol: 'ANC',
    //   name: 'Anchor Token',
    //   terraAddress: 'terra1747mad58h0w4y589y3sk84r5efqdev9q4r02pc',
    //   imgSrc: 'https://whitelist.anchorprotocol.com/logo/ANC.png',
    //   decimals: 6,
    // },
    // {
    //   symbol: 'MIR',
    //   name: 'Mirror',
    //   terraAddress: 'terra10llyp6v3j3her8u3ce66ragytu45kcmd9asj3u',
    //   imgSrc: 'https://whitelist.mirror.finance/icon/MIR.png',
    //   decimals: 6,
    // },
    // {
    //   symbol: 'bLUNA',
    //   name: 'Anchor bLUNA Token',
    //   terraAddress: 'terra1u0t35drzyy0mujj8rkdyzhe264uls4ug3wdp3x',
    //   imgSrc: 'https://whitelist.anchorprotocol.com/logo/bLUNA.png',
    //   decimals: 6,
    // },
    {
      symbol: 'LUNA',
      name: 'LUNA Token',
      terraAddress: 'uluna',
      imgSrc: 'https://assets.terra.money/icon/60/Luna.png',
      decimals: 6,
    },
    {
      symbol: 'UST',
      name: 'Terra USD',
      terraAddress: 'uusd',
      imgSrc: 'https://assets.terra.money/icon/60/UST.png',
      decimals: 6,
    },
    {
      symbol: 'LunaX',
      name: 'LunaX',
      terraAddress: 'terra1v0ypm2yc96alhn634pnwt4q4px482ukfqk02hx',
      imgSrc: 'https://terra.staderlabs.com/static/lunax.png',
      decimals: 6,
    },
    {
      symbol: 'aUST',
      name: 'Anchor Terra USD',
      terraAddress: 'terra1ajt556dpzvjwl0kl5tzku3fc3p3knkg9mkv8jl',
      imgSrc: 'https://whitelist.anchorprotocol.com/logo/aUST.png',
      decimals: 6,
    },
  ],
}

export type AssetData = {
  symbol: string
  name: string
  decimals: number
  terraAddress: string
  imgSrc?: string
}
